export default function ErrorPage() {
  return <div className="flex flex-col justify-center items-center h-full bg-gray-300 text-gray-800 h-screen">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/images/intalent_logo_text_black.png" width={256} height={43} alt="Intalent Logo" className="mb-6 h-auto w-64 object-contain" />
            <h1 className="text-4xl font-bold mb-4">Something went wrong!</h1>
            <p className="text-lg mb-6 text-center">
                Please refresh this page. If you keep seeing this error, please contact support at{' '}
                <a href="mailto:support@intalent.ai" className="text-blue-400 underline cursor-pointer">
                    support@intalent.ai
                </a>
            </p>
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
            <a href="/" className="px-5 py-3 bg-blue-500 text-white rounded-md text-lg font-medium hover:bg-blue-600 transition duration-300">
                Home
            </a>
        </div>;
}